/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  var FABRIC_METRE_MULTIPLIER = 4;

  function formatFabricMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }

    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function getFabricProductJson(section) {
    if (!section) return null;

    var productJsonScript = section.querySelector('[data-product-json]');
    if (!productJsonScript) return null;

    try {
      return JSON.parse(productJsonScript.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedFabricVariant(section, product) {
    if (!section || !product || !product.variants) return null;

    var selectedVariantInput = section.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!selectedVariantInput) return product.variants[0];

    var selectedVariantId = Number(selectedVariantInput.value);

    return product.variants.find(function(variant) {
      return Number(variant.id) === selectedVariantId;
    }) || product.variants[0];
  }

  function updateFabricProductPrice(section, variantFromEvent) {
    if (!section) return;

    var priceElement = section.querySelector('[data-fabric-price]');
    if (!priceElement) return;

    var product = getFabricProductJson(section);
    var variant = variantFromEvent || getSelectedFabricVariant(section, product);

    if (!variant || typeof variant.price === 'undefined') return;

    var quarterPrice = Number(variant.price);
    var metrePrice = quarterPrice * FABRIC_METRE_MULTIPLIER;

    priceElement.innerHTML =
      formatFabricMoney(metrePrice) +
      '<span class="fabric-price-label"> per metre</span>' +
      '<small class="fabric-quarter-price">(' + formatFabricMoney(quarterPrice) + ' per 25cm)</small>';
  }

  function updateAllFabricProductPrices() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function(section) {
      updateFabricProductPrice(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(updateAllFabricProductPrices, 300);
  });

  document.addEventListener('theme:variant:change', function(event) {
    var section = event.target.closest('[data-section-type="product"]');
    var variant = event.detail && event.detail.variant ? event.detail.variant : null;

    setTimeout(function() {
      updateFabricProductPrice(section, variant);
    }, 50);
  });


    function formatMetresFromQuantity(quantity) {
    var metres = Number(quantity) / 4;

    if (isNaN(metres)) {
      metres = 1;
    }

    return metres.toFixed(2);
  }

  function quantityFromMetres(metres) {
    var value = Number(metres);

    if (isNaN(value)) {
      value = 1;
    }

    if (value < 0.5) {
      value = 0.5;
    }

    value = Math.round(value / 0.25) * 0.25;

    return Math.round(value * 4);
  }

  function updateFabricMeterSelector(selector) {
    var realInput = selector.querySelector('[data-fabric-real-quantity]');
    var displayInput = selector.querySelector('[data-fabric-meter-display]');
    var toggleText = selector.querySelector('[data-popout-toggle-text]');

    if (!realInput || !displayInput) return;

    var realQuantity = Number(realInput.value);

    if (isNaN(realQuantity) || realQuantity < 2) {
      realQuantity = 4;
    }

    var metreValue = formatMetresFromQuantity(realQuantity);

    displayInput.value = metreValue;

    if (toggleText) {
      toggleText.innerHTML = metreValue + ' m';
    }
  }

  function initFabricMeterSelectors() {
    var selectors = document.querySelectorAll('[data-fabric-meter-selector]');

    selectors.forEach(function(selector) {
      if (selector.dataset.fabricMeterReady === 'true') {
        updateFabricMeterSelector(selector);
        return;
      }

      var realInput = selector.querySelector('[data-fabric-real-quantity]');
      var displayInput = selector.querySelector('[data-fabric-meter-display]');

      if (!realInput || !displayInput) return;

      realInput.addEventListener('change', function() {
        updateFabricMeterSelector(selector);
      });

      displayInput.addEventListener('change', function() {
        realInput.value = quantityFromMetres(displayInput.value);
        realInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateFabricMeterSelector(selector);
      });

      displayInput.addEventListener('blur', function() {
        realInput.value = quantityFromMetres(displayInput.value);
        realInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateFabricMeterSelector(selector);
      });

      selector.dataset.fabricMeterReady = 'true';

      updateFabricMeterSelector(selector);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initFabricMeterSelectors, 300);
  });

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initFabricMeterSelectors, 300);
  });



    function cartQuantityFromMetres(metres) {
    var value = Number(metres);

    if (isNaN(value)) {
      value = 1;
    }

    if (value < 0.5) {
      value = 0.5;
    }

    value = Math.round(value / 0.25) * 0.25;

    return Math.round(value * 4);
  }

  function cartMetresFromQuantity(quantity) {
    var metres = Number(quantity) / 4;

    if (isNaN(metres)) {
      metres = 1;
    }

    return metres.toFixed(2);
  }

  function initFabricCartMeters() {
    document.querySelectorAll('[data-fabric-cart-meter-field]').forEach(function(displayInput) {
      if (displayInput.dataset.fabricCartReady === 'true') return;

      var cartQuantityWrapper = displayInput.closest('.cart__quantity');
      if (!cartQuantityWrapper) return;

      var realInput = cartQuantityWrapper.querySelector('[data-fabric-cart-real-quantity]');
      if (!realInput) return;

      function syncDisplayFromReal() {
        displayInput.value = cartMetresFromQuantity(realInput.value);
      }

      function syncRealFromDisplay() {
        realInput.value = cartQuantityFromMetres(displayInput.value);
        realInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      displayInput.addEventListener('change', function() {
        syncRealFromDisplay();
      });

      displayInput.addEventListener('blur', function() {
        syncRealFromDisplay();
      });

      displayInput.dataset.fabricCartReady = 'true';

      syncDisplayFromReal();
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initFabricCartMeters, 500);
  });

  document.addEventListener('cart:updated', function() {
    setTimeout(initFabricCartMeters, 500);
  });

  document.addEventListener('theme:cart:change', function() {
    setTimeout(initFabricCartMeters, 500);
  });


    function initFabricAddonButtons() {
    var buttons = document.querySelectorAll('[data-fabric-addon-atc]');

    buttons.forEach(function(button) {
      if (button.dataset.fabricAddonReady === 'true') return;

      button.addEventListener('click', function() {
        var variantId = Number(button.dataset.variantId);
        var propertyName = button.dataset.propertyName;
        var propertyValue = button.dataset.propertyValue;
        var productImage = button.dataset.parentImageUrl;
        var wrapper = button.closest('[data-fabric-addon-actions]');
        var message = wrapper ? wrapper.querySelector('[data-fabric-addon-message]') : null;

        if (!variantId) return;

        var originalText = button.textContent;

        button.disabled = true;
        button.textContent = 'ADDING...';

        var properties = {};

        if (propertyName && propertyValue) {
          properties[propertyName] = propertyValue;
        }

        if (productImage) {
          properties['_image'] = productImage;
          properties['Fabric image'] = productImage;
        }

        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: properties
              }
            ]
          })
        })
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Unable to add item');
            }

            return response.json();
          })
          .then(function() {
            button.textContent = 'ADDED';

            if (message) {
              message.textContent = 'Added to cart.';
            }

            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('theme:cart:change'));

            setTimeout(function() {
              button.disabled = false;
              button.textContent = originalText;

              if (message) {
                message.textContent = '';
              }
            }, 1800);
          })
          .catch(function() {
            button.disabled = false;
            button.textContent = originalText;

            if (message) {
              message.textContent = 'Could not add item. Please try again.';
            }
          });
      });

      button.dataset.fabricAddonReady = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initFabricAddonButtons, 300);
  });

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initFabricAddonButtons, 300);
  });

  
  // For frontend calculation
  function updateFabricProductTotal(section, variantFromEvent) {
  if (!section) return;

  var fabricSelector = section.querySelector('[data-fabric-meter-selector]');
  if (!fabricSelector) return;

  var totalElement = section.querySelector('[data-fabric-product-total]');
  if (!totalElement) return;

  var totalPriceElement = totalElement.querySelector('[data-fabric-product-total-price]');
  if (!totalPriceElement) return;

  var product = getFabricProductJson(section);
  var variant = variantFromEvent || getSelectedFabricVariant(section, product);

  if (!variant || typeof variant.price === 'undefined') return;

  var realInput = section.querySelector('[data-fabric-real-quantity]');
  var realQuantity = realInput ? Number(realInput.value) : 4;

  if (isNaN(realQuantity) || realQuantity < 2) {
    realQuantity = 4;
  }

  var totalPrice = Number(variant.price) * realQuantity;

  totalPriceElement.textContent = formatFabricMoney(totalPrice);
}
function initFabricProductTotals() {
  document.querySelectorAll('[data-fabric-product-total]').forEach(function(totalBlock) {
    var section = totalBlock.closest('[data-section-type="product"]') || document;

    updateFabricProductTotal(section);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(initFabricProductTotals, 400);
});

document.addEventListener('shopify:section:load', function() {
  setTimeout(initFabricProductTotals, 400);
});

document.addEventListener('theme:variant:change', function(event) {
  var section = event.target.closest('[data-section-type="product"]') || document;
  var variant = event.detail && event.detail.variant ? event.detail.variant : null;

  setTimeout(function() {
    updateFabricProductTotal(section, variant);
  }, 100);
});

document.addEventListener('click', function(event) {
  if (
    event.target.closest('.fabric-meter-counter .quantity__plus') ||
    event.target.closest('.fabric-meter-counter .quantity__minus')
  ) {
    var section = event.target.closest('[data-section-type="product"]') || document;

    setTimeout(function() {
      updateFabricProductTotal(section);
    }, 150);
  }
});

document.addEventListener('change', function(event) {
  if (
    event.target.matches('[data-fabric-meter-display]') ||
    event.target.matches('[data-fabric-real-quantity]')
  ) {
    var section = event.target.closest('[data-section-type="product"]') || document;

    setTimeout(function() {
      updateFabricProductTotal(section);
    }, 150);
  }
});

document.addEventListener('input', function(event) {
  if (event.target.matches('[data-fabric-meter-display]')) {
    var section = event.target.closest('[data-section-type="product"]') || document;

    setTimeout(function() {
      updateFabricProductTotal(section);
    }, 150);
  }
});




  // ^^ Keep your scripts inside this IIFE function call to   
  // avoid leaking your variables into the global scope.
})();
